window.addEventListener('load',() => {
  document.querySelector('.facets__header-vertical').style.display = 'none';
  document.querySelector('.mobile-facets__info').style.display = 'none';
  document.querySelectorAll('.facets__price').forEach((el) => {
    el.style.display = 'none';
  });
})

const numberWithSpaces = (number) => {
    return parseFloat(number).toFixed(2);
}

const initNucleoPriceSlider = (type) => {
  let priceInputs = document.querySelectorAll('.facets__price');
  if(type === 'mobile') {
    priceInputs = document.querySelectorAll('.mobile-facets .facets__price');  
  } else if(type === 'desktop') {
    priceInputs = document.querySelectorAll('.facets .facets__price');  
  }
  if(priceInputs.length) {
    priceInputs.forEach((el) => {
      let priceInputGTE = el.querySelector('[name="filter.v.price.gte"]');
      let priceInputLTE = el.querySelector('[name="filter.v.price.lte"]');
      
      // Create element.
      const nucleoPriceRange = document.createElement("div");
      nucleoPriceRange.classList.add('npr');
      let nucleoPriceRangeMin = parseFloat( priceInputGTE.getAttribute('min') );
      let nucleoPriceRangeMax = parseFloat( priceInputGTE.getAttribute('max') );
      nucleoPriceRange.innerHTML = '<div id="npr_price-slider"><input id="npr_min" type="range" min="0" max="'+nucleoPriceRangeMax+'" value="0" step="0.05"><input id="npr_max" type="range" min="0" max="'+nucleoPriceRangeMax+'" value="'+nucleoPriceRangeMax+'" step="0.05"></div><div id="npr_price-slider_text"><span id="npr_from"></span><span id="npr_to"></span></div>';
      el.insertAdjacentElement('afterend',nucleoPriceRange);
      
      let nprMinSlider = el.nextSibling.querySelector('#npr_min')
      let nprMinText = el.nextSibling.querySelector('#npr_from')
      
      let nprMaxSlider = el.nextSibling.querySelector('#npr_max')
      let nprMaxText = el.nextSibling.querySelector('#npr_to')
      
      const updatePricing = () => {   
        nprMinText.textContent = `$${numberWithSpaces(nprMinSlider.value)}`
        priceInputGTE.value = nprMinSlider.value;
        
        nprMaxText.textContent = `$${numberWithSpaces(nprMaxSlider.value)}`
        priceInputLTE.value = nprMaxSlider.value;
      }
    
      // Set values on load.
      nprMinText.textContent = `$${numberWithSpaces(nprMinSlider.value)}`
      nprMaxText.textContent   = `$${numberWithSpaces(nprMaxSlider.value)}`
      
      nprMaxSlider.addEventListener('input', (el) => {
        let minValue = parseFloat(nprMinSlider.value)
        let maxValue = parseFloat(nprMaxSlider.value)
         
        if (maxValue < minValue) {
          nprMinSlider.value = maxValue
            
          if (minValue === parseFloat(nprMinSlider.min)) {
            nprMaxSlider.value = 0
          }
        }
      
        updatePricing()
      })
      
      nprMinSlider.addEventListener('input', () => {
        let minValue = parseFloat(nprMinSlider.value)
        let maxValue = parseFloat(nprMaxSlider.value)
       
        if (minValue > maxValue) {
          nprMaxSlider.value = minValue
            
          if (maxValue === parseFloat(nprMaxSlider.max)) {
            nprMinSlider.value = parseFloat(nprMaxSlider.max)
          }
        }
      
        updatePricing()
      })      
    })
  }
}

document.addEventListener('DOMContentLoaded',() => {
  initNucleoPriceSlider(); 
})

// Listen for changes to facets and re-init slider as needed.
let activeFacetsDesktop = document.querySelector('.active-facets-desktop');
let observerCallbackDesktop = (mutations, observer) => {
  for (let mutation of mutations) {
    if (mutation.type === 'childList') {
      let target = mutation.target;
      let parent = target.parentNode;
      if( null === parent.querySelector('.npr')) {
        initNucleoPriceSlider('desktop');
        return;
      }
    }
  }
}
let observerDesktop = new MutationObserver(observerCallbackDesktop);
observerDesktop.observe(activeFacetsDesktop, { childList: true});

let activeFacetsMobile = document.querySelector('.active-facets-mobile');
let observerCallbackMobile= (mutations, observer) => {
  for (let mutation of mutations) {
    if (mutation.type === 'childList') {
      if( null === document.querySelector('.mobile-facets .npr')) {
        initNucleoPriceSlider('mobile');
        return;
      }
    }
  }
}
let observerMobile = new MutationObserver(observerCallbackMobile);
observerMobile.observe(activeFacetsMobile, { childList: true});
